export default "__VITE_ASSET__DoZEX7wM__"